import { FeatureFlag, ResolverTag } from '@ps/web-core-enums';
import { type Dispatch, useFeature } from '@ps/web-core-store';
import { canUseDOM } from '@ps/web-core-utils';
import { useNavigate, useResolver } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { select } from '@swf/core/store';

import Card from '../Card/Card';

const PowerPathCard: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const powerPathLobbyLink = useResolver(ResolverTag.PowerPathLobby);
  const webPokerEnabled = useFeature(FeatureFlag.WebPokerEnabled);
  const navigate = useNavigate();
  const history = useHistory();

  const navigateToPowerPathLobby = () => {
    if (isEmbedded && canUseDOM) {
      window.starsweb?.app.execute('powerpath');
    } else {
      const powerPath = powerPathLobbyLink
        ? new URL(powerPathLobbyLink).pathname.replace('//', '/')
        : '';
      if (powerPath && webPokerEnabled) {
        navigate(powerPath);
        modal.close();
      } else {
        history.push('/prhub/featured/power-path-lobby');
      }
    }
  };
  return <Card onClick={navigateToPowerPathLobby} variant="PowerPath" />;
};

export default PowerPathCard;
